module.exports = __webpack_public_path__ + "media/images/items/static-5-9828d03ad62889ad337c854a779bf6df.jpg";